export class DecryptCreditCardRequest {

    CardID: number;
    AdminUsername: string;
    AdminPassword: string;

}
